<div class="max-w-screen-xl p-6 mx-auto bg-white shadow-md rounded-xl">

  <!-- Section Informations sur la licence -->
  <div class="p-6 mb-6 border border-purple-200 bg-purple-50 rounded-xl">
    <h2 class="mb-4 text-2xl font-semibold text-purple-800">Informations sur la licence</h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <p class="text-sm font-medium text-purple-700">Numéro de licence</p>
        <p class="text-lg font-semibold text-purple-900">CERTI-GA-2025-001-FREE</p>
      </div>
      <div>
        <p class="text-sm font-medium text-purple-700">Type de licence</p>
        <p class="text-lg font-semibold text-purple-900">Gratuité</p>
      </div>
      <div>
        <p class="text-sm font-medium text-purple-700">Périodicité</p>
        <p class="text-lg font-semibold text-purple-900">3 mois</p>
      </div>
      <div>
        <p class="text-sm font-medium text-purple-700">Date d'expiration</p>
        <p class="text-lg font-semibold text-purple-900">31/11/2025</p>
      </div>
    </div>
  </div>

</div>
